import { connect } from "react-redux";
import queryString from "query-string";

import EditInstitution from "../components/EditInstitution";
import * as actions from "../actions";
import * as selectors from "../selectors";

const mapStateToProps = (state, ownProps) => {
  const query_string = queryString.parse(location.search);
  const edit_institution = selectors.getInstitutionDetail(state) || {};

  const struct = {
    paramsKey: ownProps.routeParams.key,
    saved: query_string.saved,
    institution: edit_institution,
    user: selectors.getUser(state),
    users: selectors.getUsers(state),
    loading_users: selectors.isLoadingUsers(state),
    isLoadingCategories: selectors.isLoadingCategories(state),
    isLoadingDistricts: selectors.isLoadingDistricts(state),
    categories: selectors.getCategories(state),
    districts: selectors.getDistricts(state),
    savingInstitution: selectors.isSavingInstitution(state),
    saveInstitutionFailed: selectors.saveInstitutionFailed(state),
    saveInstitutionErrors: selectors.saveInstitutionErrors(state)
  };
  if (edit_institution._key) {
    struct.initialValues = edit_institution;
  }
  return struct;
};

const mapDispatchToProps = dispatch => {
  return {
    onLoadUsers: () => dispatch(actions.fetchUsers()),
    onSubmit: data => dispatch(actions.saveInstitution(data)),
    onLoadEntry: key => dispatch(actions.fetchInstitution(key))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditInstitution);



/** WEBPACK FOOTER **
 ** ./src/containers/EditInstitutionContainer.js
 **/